import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';
import Link from 'next/link';

const TermsAndConditionsPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('termsAndConditions.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('termsAndConditions.pageHeading')}</h1>
        <p>
          <em>
            <strong>Algemene voorwaarden deBanenSite.nl B.V.</strong>
          </em>
        </p>
        <p>
          <em>
            <strong>deBanenSite.nl® is een geregisteerd merk.</strong>
          </em>
        </p>
        <p>
          <em>
            <strong>Algemene voorwaarden: </strong>
          </em>
          <em>
            <strong>deBanenSite.nl </strong>
          </em>
          <em>
            <strong>hierna te noemen dBS.</strong>
          </em>
        </p>
        <h2 className="h3">Artikel 1 toepasselijkheid</h2>
        <p>
          <strong>1.1&nbsp;&nbsp;</strong>Deze algemene voorwaarden zijn van
          toepassing op iedere aanbieding, offerte en overeenkomst tussen dBS en
          een opdrachtgever waarop dBS deze voorwaarden van toepassing heeft
          verklaard.
        </p>
        <p>
          <strong>1.2&nbsp;&nbsp;</strong>Opdrachtgever aanvaardt de
          toepasselijkheid van deze algemene voorwaarden. De toepasselijkheid
          van eventuele inkoop- of andere voorwaarden van opdrachtgever wordt
          uitdrukkelijk van de hand gewezen.
        </p>
        <p>
          <strong>1.3&nbsp;&nbsp;</strong>Eventuele afwijkingen van deze
          algemene voorwaarden zijn slechts geldig indien deze uitdrukkelijk
          schriftelijk zijn overeengekomen.
        </p>
        <p>
          <strong>1.4</strong> De opdrachtgever is de entiteit met een
          inschrijving bij de Kamer van Koophandel.
        </p>
        <p>
          <strong>1.5&nbsp;&nbsp;</strong>Indien een of meerdere bepalingen in
          deze algemene voorwaarden nietig zijn of nietig verklaard mochten
          worden, blijven de overige bepalingen van deze algemene voorwaarden
          volledig van toepassing. In dat geval zullen dBS en opdrachtgever in
          overleg treden teneinde nieuwe bepalingen ter vervanging van de
          nietige en/of vernietigde bepalingen overeen te komen, waarbij zoveel
          mogelijk het doel en de strekking van de oorspronkelijke bepaling in
          acht te zullen nemen.
        </p>
        <p>
          <strong>1.6</strong> Deze Algemene voorwaarden zijn van toepassing op
          huidige-, in het verleden afgesloten- en nieuw af te sluiten
          overeenkomsten.
        </p>
        <h2 className="h3">Artikel 2 Definities</h2>
        <p>
          <strong>2.1</strong> In deze algemene voorwaarden worden de hierna
          volgende termen in de navolgende betekenis gebruikt:
        </p>
        <p>
          &nbsp;(a)&nbsp;&nbsp;&nbsp; internetsite:
          <br /> de door dBS op Internet verzorgde portal die voor iedereen
          toegankelijk is via de internetsite www.deBanenSite.nl, alsmede alle
          andere internetsites van dBS die toegankelijk zijn via aan deze
          domeinnaam gerelateerde sublevel domeinnamen.
        </p>
        <p>
          (b)&nbsp;&nbsp; opdrachtgever:
          <br /> de natuurlijke of ieder (rechts)persoon met wie een
          overeenkomst wordt gesloten en / of die van de diensten van dBS
          gebruik maakt zoals onder meer aangeboden wordt op de site.
        </p>
        <p>
          (c)&nbsp;&nbsp;&nbsp; overeenkomst/abonnement:
          <br /> de afspraken tot dienstverlening tussen dBS en opdrachtgever op
          grond waarvan dBS diensten aan opdrachtgever ter beschikking stelt,
          welke schriftelijk, digitaal of telefonisch zijn vastgelegd en waarop
          deze algemene voorwaarden van toepassing zijn.
        </p>
        <p>
          (d)&nbsp;&nbsp; diensten:
          <br /> de dienst(en) zoals vastgelegd in de overeenkomst/abonnement
          gesloten tussen opdrachtgever en dBS.
        </p>
        <h2 className="h3">Artikel 3 Voorstellen en offertes</h2>
        <p>
          <strong>3.1</strong> De door dBS gemaakte offertes zijn vrijblijvend
          en geldig gedurende maximaal 14 dagen, tenzij anders aangegeven.
        </p>
        <p>
          <strong>3.2</strong> dBS is slechts aan de offertes gebonden indien de
          aanvaarding hiervan door de wederpartij schriftelijk (of per e-mail)
          binnen 14 dagen worden bevestigd, of bij een mondelinge (ook
          telefonische) opdracht, die door dBS schriftelijk wordt bevestigd
          middels een opdrachtbevestiging, zijnde de bevestiging opdracht e-mail
          en de factuur.
        </p>
        <p>
          <strong>3.3</strong> De prijzen/tarieven in de genoemde aanbiedingen
          en offertes zijn exclusief BTW (21 %), eventuele kredietbeperking en
          heffingen van overheidswege, alsmede eventuele in het kader van de
          overeenkomst te maken kosten, waaronder verzend- en
          administratiekosten, tenzij anders aangegeven. Prijzen/tarieven worden
          jaarlijks geindexeerd.
        </p>
        <p>
          <strong>3.4</strong> Aanbiedingen of offertes gelden niet automatisch
          voor toekomstige opdrachten. Er worden geen media- en of
          bureaukortingen gegeven op de tarieven.
        </p>
        <h2 className="h3">Artikel 4 Uitvoering van de overeenkomst</h2>
        <p>
          <strong>4.1</strong> De opdrachtgever draagt zorg dat alle gegevens,
          waarvan dBS aangeeft dat deze noodzakelijk zijn of waarvan de
          opdrachtgever redelijkerwijs behoort te begrijpen dat deze
          noodzakelijk zijn voor het uitvoeren van de overeenkomst, tijdig aan
          dBS worden verstrekt.
        </p>
        <p>
          <strong>4.2. </strong>De informatie en vacaturetekst die de
          opdrachtgever verstrekt aan dBS voldoet aan alle eisen die de
          Nederlandse wetgever stelt.
        </p>
        <p>
          <strong>4.3</strong> Indien de voor de uitvoering van de overeenkomst
          benodigde gegevens niet tijdig of onbruikbaar of niet compleet en/of
          beschadigd aan dBS zijn verstrekt, heeft dBS het recht de uitvoering
          van de overeenkomst op te schorten.
        </p>
        <p>
          <strong>4.4</strong> dBS is niet aansprakelijk voor schade, van welke
          aard ook, doordat dBS is uitgegaan van door de opdrachtgever
          verstrekte gegevens.
        </p>
        <p>
          <strong>4.5</strong> dBS is niet aansprakelijk voor een minimum aantal
          of minimum kwaliteit van sollicitaties en/of reacties vanwege
          gebruikers (werkzoekenden / kandidaten) op de vacatures van de
          opdrachtgever.
        </p>
        <p>
          <strong>4.6</strong> dBS is niet aansprakelijk voor investeringen die
          de opdrachtgever heeft gedaan met betrekking tot de overeenkomst en
          het aantal sollicitaties.
        </p>
        <p>
          <strong>4.7</strong> Een annulering of wijziging van een opdracht
          dient schriftelijk (of per e-mail) plaats te vinden en dient uiterlijk
          twee werkdagen na het aanmaken van een vacature, doch vóór het online
          plaatsen van de vacature, door dBS te zijn ontvangen.
        </p>
        <p>
          <strong>4.8</strong> Indien een opdracht niet tijdig is geannuleerd of
          gewijzigd, dan is de opdrachtgever het volledige bedrag zoals
          beschreven in de opdrachtbevestiging verschuldigd.
        </p>
        <h2 className="h3">
          Artikel 5 Opschorting, ontbinding en opzegging van overeenkomst
        </h2>
        <p>
          <strong>5.1</strong> dBS is te allen tijde gerechtigd om zonder opgave
          van redenen opdrachten te weigeren, te annuleren of de uitvoering
          daarvan op te schorten, zonder dat dit op enigerlei wijze kan leiden
          tot schadeverplichtingen.
        </p>
        <p>
          <strong>5.2</strong> Deze bevoegdheid (5.1) van dBS geldt eveneens
          voor opdrachten waaraan reeds gedeeltelijk uitvoering is gegeven.
        </p>
        <p>
          <strong>5.3</strong> Reclame-uitingen moeten voldoen aan de eisen die
          de Nederlandse Wetgeving en Reclame Code Commissie stelt.
        </p>
        <p>
          <strong>5.4</strong> dBS behoudt zich het recht voor om tekst en vorm
          van alle advertenties, die voor plaatsing op de internetsite worden
          aangeboden, in alle redelijkheid te wijzigen.
        </p>
        <p>
          <strong>5.5</strong> Opdrachtgever mag uitsluitend daadwerkelijk
          bestaande, bedrijfs herkenbare en concrete, op het moment van
          plaatsing, openstaande vacatures plaatsen op de internetsite. Het is
          niet toegestaan om meerdere en/of verschillende functies en/of
          meerdere plaatsnamen in één vacatureplaatsing te plaatsen en/of te
          noemen.
        </p>
        <p>
          <strong>5.6</strong> Indien blijkt dat de door de opdrachtgever
          verstrekte vacaturetekst niet aan wettelijke eisen voldoet of
          discriminerend is, heeft dBS het recht deze te verwijderen van de site
          zonder enige vergoeding aan opdrachtgever.
        </p>
        <h2 className="h3">Artikel 6 Contractduur; uitvoeringstermijn</h2>
        <p>
          <strong>6.1</strong> Door de aankoop van een vacature-tegoed(credits)
          verkrijgt de opdrachtgever het recht om vacature(s) te plaatsen. Dit
          tegoed is onbeperkt geldig.
        </p>
        <p>
          <strong>6.2</strong> Aangeschaft vacature-tegoed(credit(s) kunnen niet
          worden ingewisseld.
        </p>
        <p>
          <strong>6.3</strong> De overeenkomst voor het plaatsen van een
          individuele vacature (credit/standaardvacature) is voor de duur van
          maximaal 90 dagen.
        </p>
        <p>
          <strong>6.4</strong> Na het sluiten van enig overeenkomst/abonnement
          stemt de opdrachtgever ermee in om via e-mail of met de post
          vragenlijsten, nieuwsbrieven en andere commerciële berichten te
          ontvangen die dBS helpen haar kwaliteitsnormen te verbeteren en te
          handhaven.
        </p>
        <p>
          <strong>6.5</strong> De opdrachtgever kan zijn toestemming voor het
          ontvangen van de onder 6.3 genoemde informatie te allen tijde
          intrekken zonder formele voorwaarden. De intrekking van de toestemming
          wordt binnen 1 maand na ontvangst van het verzoek van kracht.
        </p>
        <p>
          <strong>6.6</strong> Beschikt de Opdrachtgever over een abonnement
          voor vacatures plaatsen/ vacatureslots/Jobslots dan behoudt dBS zich
          het recht voor om maatregelen te nemen bij excessief gebruik of
          overbelasting van het platform.
        </p>
        <p>
          <strong>6.7</strong> Sollicitaties worden automatisch in het systeem
          van dBS bijgehouden.
        </p>
        <p>
          <strong>6.8</strong> Elke overeenkomst/abonnement wordt aangegaan voor
          de aangegeven periode en automatisch verlengd met eenzelfde periode,
          tenzij tenminste 1 maand vóór de afloopdatum per e-mail/schriftelijk
          is opgezegd.
        </p>
        <p>
          <strong>6.9</strong> Prijzen/tarieven worden jaarlijks geindexeerd.
        </p>
        <p>
          <strong>6.10</strong> Bij beëindiging van de overeenkomst/abonnement
          vervalt ook de toegang tot de CV-Database.
        </p>
        <p>
          <strong>6.11</strong> Het gebruik van het dashboard/HR-tool is
          gekoppeld aan de duur van de overeenkomst/abonnement(6.8).
        </p>
        <p>
          <strong>6.12</strong> Elke overeenkomst/abonnement is enkel van
          toepassing voor gebruik opdrachtgever betreffende één (1)
          bedrijfsnaam.
        </p>
        <p>
          <strong>6.13</strong> CV-Database toegang is gesteld op een fair use
          policy van 100 CV's inzien / downloaden per maand.
        </p>
        <p>
          <strong>6.14</strong> Opzegging van een overeenkomst/abonnement is
          tenminste 1 maand vóór de afloopdatum per e-mail/schriftelijk
          mogelijk.
        </p>
        <p>
          <strong>6.15</strong> Tussentijdse beëindiging is mogelijk, ingeval
          één van beide partijen in staat van faillissement geraakt, surseance
          van betaling aanvraagt, heeft de andere partij het recht de
          overeenkomst zonder inachtneming van een opzegtermijn te beëindigen,
          een en ander onder behoud van rechten.
        </p>
        <h2 className="h3">Artikel 7 Vacatureteksten</h2>
        <p>
          <strong>7.1</strong> Vacatures worden door opdrachtgever geplaatst op
          de internetsite. Uit service overwegingen(vacatureservice) kunnen
          vacatures ook door dBS worden geplaatst.
        </p>
        <p>
          <strong>7.2</strong> Vacatures die op de internetsite worden
          gepubliceerd kunnen door middel van scannen en tekstherkenning zijn
          overgenomen uit oorspronkelijke bronnen.
        </p>
        <p>
          <strong>7.3</strong> Ondanks de hoge zorg die dBS besteedt aan
          correcte plaatsingen op de internetsite, zijn fouten niet uitgesloten.
          Om deze reden kunnen er, naast inhoudelijke onjuistheden, tevens
          onjuistheden voorkomen bij de selectie van vacature(s), zowel online
          als via de vacatureservice. Aan de gepresenteerde teksten kunnen geen
          rechten worden ontleend.
        </p>
        <p>
          <strong>7.4</strong> dBS is niet verantwoordelijk voor de schade die
          direct of indirect ontstaat door gebruik van de informatie die aan de
          site wordt ontleend.
        </p>
        <p>
          <strong>7.5</strong> dBS is niet aansprakelijk voor de juistheid van
          de gegevens die op verzoek van de opdrachtgever of de gebruiker door
          dBS werden gepubliceerd. dBS is niet aansprakelijk voor de
          verklaringen in deze gegevens.
        </p>
        <p>
          <strong>7.5</strong> Opdrachtgever is volledig verantwoordelijk voor
          de gepubliceerde bedrijfsinformatie, vacature(s), vacaturetekst(en) en
          de wettelijke eisen die gesteld worden.
        </p>
        <h2 className="h3">Artikel 8 Eigendom</h2>
        <p>
          <strong>8.1</strong> Alle op de site gepubliceerde vacature-,
          bedrijfs- en CV gegevens (alle content) zijn eigendom van dBS.
        </p>
        <p>
          <strong>8.2</strong> Het is niet toegestaan gegevens zonder
          toestemming geheel of ten dele over te nemen, op een andere wijze te
          publiceren of door te verkopen aan derden dan wel aan opdrachtgever
          gelieerde partijen, of anderszins op commerciële grondslag ter
          beschikking stellen aan derden van wel aan opdrachtgever gelieerde
          partijen, zonder toestemming van dBS.
        </p>
        <h2 className="h3">Artikel 9 Privacy</h2>
        <p>
          <strong>9.1</strong> Privacy voorwaarden van dBS staan op de pagina{' '}
          <Link href="/privacy">Privacy</Link>.
        </p>
        <p>
          <strong>9.2</strong> Telefoongesprekken kunnen met het oog op
          informatieverstrekking, opdrachtverstrekking, training, coaching en
          beoordeling (o.a. van medewerkers) worden opgenomen. Deze opnamen van
          telefoongesprekken worden zodanig beveiligd en bewaard dat deze niet
          toegankelijk zijn voor onbevoegden. De opnamen van telefoongesprekken
          worden niet langer bewaard dan noodzakelijk.
        </p>
        <h2 className="h3">Artikel 10 Facturatie & Betaling</h2>
        <p>
          <strong>10.1</strong> dBS factureert bij aanvang van de
          overeenkomst/abonnement het verschuldigde bedrag in zijn geheel,
          tenzij anders is overeengekomen(bijvoorbeeld maandelijks). dBS kan
          facturen zowel per gewone post als elektronisch verzenden.
          Opdrachtgever gaat akkoord met elektronische facturatie door dBS.
        </p>
        <p>
          <strong>10.2</strong> dBS behoudt zich het recht voor de
          prijzen/tarieven van de Dienst(en) en andere producten te herzien of
          te wijzigen. Jaarlijks worden de prijzen/tarieven geindexeerd. dBS zal
          dergelijke prijswijzigingen of herzieningen minstens 14 (veertien)
          dagen van tevoren aankondigen.
        </p>
        <p>
          <strong>10.3</strong> Opdrachtgever is gehouden facturen binnen 14
          dagen na de factuurdatum te betalen tenzij anders overeengekomen. Het
          recht van verrekening en opschorting door de opdrachtgever is
          uitgesloten.
        </p>
        <p>
          <strong>10.4</strong> Heeft na factuurdatum binnen vermelden dagen
          geen betaling plaatsgevonden, is de opdrachtgever van rechtswege in
          verzuim; de opdrachtgever is vanaf het moment van in verzuim treden
          over het opeisbare bedrag een rente verschuldigd gelijk aan de
          geldende wettelijke rente.
        </p>
        <p>
          <strong>10.5</strong> Betaling dient plaats te vinden zonder enige
          korting of verrekening en zonder dat opdrachtgever zich op opschorting
          kan beroepen tenzij schriftelijk anders is overeengekomen.
        </p>
        <p>
          <strong>10.6</strong> Wanneer opdrachtgever wordt geliquideerd,
          faillissement (dreigt), surseance van betaling of toepassing van de
          Wet Schuldsanering Natuurlijke Personen aanvraagt of wordt aangevraagd
          en /of zijn schuldenaren een akkoord aanbiedt, zullen de
          verplichtingen van de opdrachtgever onmiddellijk opeisbaar zijn.
        </p>
        <h2 className="h3">Artikel 11 Incassokosten</h2>
        <p>
          <strong>11.1</strong> Is opdrachtgever in gebreke of in verzuim bij
          het nakomen van één of meer van zijn verplichtingen, dan komen alle
          redelijke kosten ter verkrijging van voldoening buiten rechte voor
          rekening van opdrachtgever.
        </p>
        <p>
          <strong>11.2</strong> Indien opdrachtgever in gebreke blijft in de
          tijdige voldoening van een geldsom, dan verbeurt hij een dadelijk
          opeisbare boete van 15% over het nog verschuldigde bedrag. Dit met een
          minimum van € 80,00. Indien dBS hogere (incasso-)kosten heeft gemaakt,
          welke redelijkerwijs noodzakelijk waren, komen ook deze voor
          vergoeding in aanmerking. De eventuele gemaakte redelijke
          gerechtelijke en executiekosten komen eveneens voor rekening van
          opdrachtgever. Opdrachtgever is over de gemaakte incassokosten rente
          verschuldigd.
        </p>
        <h2 className="h3">Artikel 12 Reclameren</h2>
        <p>
          <strong>12.1</strong> Klachten over de verrichte werkzaamheden dienen
          door de opdrachtgever binnen 3 dagen na ontdekking, doch uiterlijk
          binnen 5 dagen na plaatsing van de vacature(s) per e-mail of
          schriftelijk te worden gemeld aan dBS. De ingebrekestelling dient een
          zo gedetailleerd mogelijke omschrijving van de tekortkoming te
          bevatten, zodat dBS in staat is adequaat te reageren. Indien een
          klacht gegrond is, zal dBS de werkzaamheden alsnog verrichten zoals
          overeengekomen, tenzij dit inmiddels voor de opdrachtgever aantoonbaar
          zinloos is geworden. Dit laatste dient door de opdrachtgever per email
          of schriftelijk kenbaar te worden gemaakt. Indien het alsnog
          verrichten van de overeengekomen werkzaamheden niet meer mogelijk of
          zinvol is, zal dBS slechts aansprakelijk zijn binnen de grenzen van
          artikel 13.
        </p>
        <h2 className="h3">Artikel 13 Aansprakelijkheid</h2>
        <p>
          <strong>13.1</strong> dBS is niet aansprakelijk voor het niet of niet
          tijdig of onjuist plaatsen van advertenties, vacatures of CV's.
          Uitsluitend in geval van grove schuld en/of opzet is de
          aansprakelijkheid van dBS in alle gevallen beperkt tot hoogstens de
          factuurwaarde van dat gedeelte van de overeenkomst, waar de
          aansprakelijkheid uit voortvloeit.
        </p>
        <p>
          <strong>13.2</strong> dBS is nimmer aansprakelijk voor directe-,
          indirecte schade, daaronder begrepen gevolgschade, gederfde winst,
          gemiste besparingen en schade door bedrijfsstagnatie.
        </p>
        <h2 className="h3">Artikel 14 Vrijwaringen</h2>
        <p>
          <strong>14.1</strong> De opdrachtgever vrijwaart dBS voor aanspraken
          van derden met betrekking tot rechten van intellectuele eigendom op
          door de opdrachtgever verstrekte materialen of gegevens, die bij de
          uitvoering van de overeenkomst worden gebruikt.
        </p>
        <p>
          <strong>14.2</strong> Indien opdrachtgever aan dBS informatiedragers,
          elektronische bestanden of software etc. verstrekt, garandeert deze
          dat de informatiedragers, elektronische bestanden of software vrij
          zijn van virussen en defecten.
        </p>
        <p>
          <strong>14.3</strong> De opdrachtgever vrijwaart dBS volledig voor
          alle mogelijke claims van de opdrachtgever en derden op enige wijze
          voortvloeiende uit en/of verband houdende met het gebruik van de
          opdrachtgever van de internetsite.
        </p>
        <h2 className="h3">
          Artikel 15 Intellectuele eigendom en auteursrechten
        </h2>
        <p>
          <strong>15.1</strong> Alle intellectuele eigendomsrechten ten aanzien
          van diensten, software, producten en materiaal, in verband met de
          voorbereiding en uitvoering van de overeenkomst, al dan niet
          ontwikkeld ten behoeve van opdrachtgever, blijven berusten bij dBS.
          dBS zal opdrachtgever vrijwaren tegen elke rechtsvordering welke
          gebaseerd is op de bewering dat door dBS zelf ontwikkelde
          programmatuur, apparatuur of materialen inbreuk maken op een in
          Nederland geldend recht van intellectuele eigendom, onder de
          voorwaarde dat opdrachtgever aan dBS onverwijld schriftelijk
          informeert over het bestaan en de inhoud van de rechtsvordering en de
          afhandeling van de zaak, waaronder het treffen van eventuele
          schikkingen, geheel overlaat aan dBS. De opdrachtgever zal daartoe de
          nodige volmachten, informatie en medewerking aan dBS verlenen om zich,
          zo nodig in naam van de opdrachtgever, tegen deze rechtsvorderingen te
          verweren.
        </p>
        <p>
          <strong>15.2</strong> Deze verplichting tot vrijwaring vervalt indien
          en voor zover de betreffende inbreuk verband houdt met wijzigingen die
          de opdrachtgever in genoemde zaken heeft aangebracht of door derden
          heeft laten aanbrengen.
        </p>
        <h2 className="h3">Artikel 16 Onderhoud en garantie</h2>
        <p>
          <strong>16.1</strong> dBS is te allen tijde gerechtigd de website
          (tijdelijk) buiten gebruik te stellen of het gebruik ervan te beperken
          in het geval dit noodzakelijk is voor het onderhouden en/of aanpassen,
          zonder dat hierdoor voor opdrachtgever enig recht op schadevergoeding
          ontstaat.
        </p>
        <p>
          <strong>16.2</strong> dBS zal zich inspannen om
          onderhoudswerkzaamheden zoveel mogelijk buiten kantooruren en in het
          weekend te laten plaatsvinden.
        </p>
        <p>
          <strong>16.3 </strong>dBS is niet verplicht opdrachtgever op de hoogte
          te stellen van het buiten gebruik stellen van de site.
        </p>
        <p>
          <strong>16.3</strong> De inhoud van dBS is met de grootst mogelijke
          zorg samengesteld. dBS garandeert echter niet: dat de systemen van dBS
          vrij zijn van onrechtmatig gebruik door derden; dat de informatie op
          dBS volledig en juist is. Dat dBS ononderbroken zal werken en vrij zal
          zijn van fouten.
        </p>
        <p>
          <strong>16.4</strong> dBS kan verwijzingen bevatten (bijvoorbeeld door
          middel van een hyperlink, banner of button) naar websites van derden.
          dBS heeft geen zeggenschap over (de inhoud van) deze websites en kan
          op geen enkele wijze aansprakelijk worden gehouden terzake de werking
          en/of inhoud van deze websites.
        </p>
        <h2 className="h3">Artikel 17 Geheimhouding</h2>
        <p>
          <strong>17.1</strong> Opdrachtgever erkent dat zij in het kader van de
          Overeenkomst de beschikking krijgt/kan krijgen over vertrouwelijke
          gegevens van dBS.
        </p>
        <p>
          <strong>17.2</strong> Opdrachtgever is verplicht tot geheimhouding van
          deze gegevens. Opdrachtgever zal deze gegevens te allen tijde
          vertrouwelijk behandelen en deze niet openbaar maken en/of
          verveelvoudigen zonder de voorafgaande uitdrukkelijke schriftelijke
          toestemming van dBS.
        </p>
        <p>
          <strong>17.3</strong> Opdrachtgever zal de gegevens en informatie als
          bedoeld in artikel 17.1 niet gebruiken voor een ander doel dan
          waarvoor zij ter beschikking zijn gesteld noch deze op enigerlei wijze
          ter beschikking stellen van derden.
        </p>
        <p>
          <strong>17.4</strong> Deze geheimhoudingsplicht geldt niet indien
          Opdrachtgever tot openbaarmaking krachtens de wet of een bindende
          uitspraak van de rechter verplicht is of indien de informatie, zonder
          dat dit veroorzaakt is doordat de onderhavige geheimhoudingsplicht is
          geschonden, van algemene bekendheid is.
        </p>
        <h2 className="h3">Artikel 18 Overmacht</h2>
        <p>
          <strong>18.1</strong> dBS is niet gehouden nakoming van enige
          verplichting jegens opdrachtgever indien hij daartoe gehinderd wordt
          als gevolg van een omstandigheid die niet is te wijten aan schuld, en
          noch krachtens de wet, een rechtshandeling of in het verkeer geldende
          opvattingen voor zijn rekening komt.
        </p>
        <p>
          <strong>18.2</strong>
          <strong>&nbsp;</strong>Onder overmacht wordt, naast hetgeen
          daaromtrent in de wet en jurisprudentie wordt begrepen verstaan: alle
          van buitenkomende oorzaken, voorzien of niet voorzien, waarop dBS geen
          invloed kan uitoefenen, doch waardoor dBS niet in staat is zijn
          verplichtingen na te komen, werkstakingen, of storingen in het bedrijf
          van dBS of van derden daaronder begrepen.
        </p>
        <p>
          <strong>18.3</strong> dBS kan gedurende de periode dat de overmacht
          voortduurt zijn verplichtingen op grond van de overeenkomst
          opschorten. Indien deze periode langer duurt dan 2 maanden, dan is
          ieder der partijen gerechtigd de overeenkomst, zonder enige
          schadevergoedingsverplichting aan de andere partij, op te zeggen.
        </p>
        <h2 className="h3">Artikel 19 Toepasselijk recht en geschillen</h2>
        <p>
          <strong>19.1</strong>
          <strong>&nbsp;</strong>Alle eventuele geschillen die uit de
          overeenkomst vloeien zullen bij uitsluiting worden beslecht door de
          bevoegde rechter te Alkmaar
        </p>
        <p>
          <strong>19.2</strong>
          <strong>&nbsp;</strong>Partijen streven ernaar een geschil in der
          minne op te lossen.
        </p>
        <p>
          <strong>19.3</strong>
          <strong>&nbsp;</strong>Partijen komen overeen dat overeenkomsten die
          via elektronisch data-, telefonisch verkeer tot stand zijn gekomen
          tussen partijen bindend zijn en dat informatie verzonden via
          elektronisch data-, telefonisch verkeer in een eventueel gerechtelijke
          procedure tussen partijen bewijskracht heeft ter zake van de tussen
          partijen bestaande afspraken.
        </p>
        <p>
          <em>
            <strong>Datum: 23 januari 2020.</strong>
          </em>
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default TermsAndConditionsPage;
